import { Component } from "react";
import { logClientError } from "@/lib/logger";

// Top-level React error boundary. Catches ANY render-time crash so the user
// never sees the raw stack trace and can recover with a Reload button.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, msg: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, msg: (error && error.message) || "Unexpected error" };
  }

  componentDidCatch(error, info) {
    logClientError("react.error_boundary", {
      msg: (error && error.message) || String(error),
      stack: info?.componentStack,
    });
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div
        data-testid="error-boundary"
        className="min-h-screen bg-black text-white flex items-center justify-center px-6"
      >
        <div className="hairline rounded-2xl p-10 max-w-md w-full text-center bg-white/[0.02]">
          <p className="font-mono text-xs text-red-brand tracking-[0.3em]">// UNEXPECTED ERROR</p>
          <h2 className="font-anton text-3xl mt-3">SOMETHING WENT SIDEWAYS</h2>
          <p className="text-white/60 mt-3 text-sm">
            The site hit a snag. Reload the page — if it happens again, email{" "}
            <a href="mailto:bookings@djspyofficial.com" className="text-red-brand underline">
              bookings@djspyofficial.com
            </a>
            .
          </p>
          <div className="mt-6 flex gap-3 justify-center">
            <button
              type="button"
              data-testid="error-reload"
              className="btn-primary"
              onClick={() => window.location.reload()}
            >
              Reload
            </button>
            <a href="/" className="btn-ghost">Home</a>
          </div>
          {this.state.msg && (
            <p className="mt-6 text-[10px] font-mono text-white/30 break-all">{this.state.msg}</p>
          )}
        </div>
      </div>
    );
  }
}
